import { render } from "./OrderStatusIndicator.vue?vue&type=template&id=11c7daba&scoped=true&ts=true"
import script from "./OrderStatusIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusIndicator.vue?vue&type=style&index=0&id=11c7daba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c7daba"],['__file',"resources/js/vue/domain/order/components/OrderStatusIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11c7daba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11c7daba', __exports__)) {
    api.reload('11c7daba', __exports__)
  }
  
  module.hot.accept("./OrderStatusIndicator.vue?vue&type=template&id=11c7daba&scoped=true&ts=true", () => {
    api.rerender('11c7daba', render)
  })

}


export default __exports__